<template>
  <div>
    <app-gridview
      v-bind:parentData="{
        tabHeaders: this.dataHeader,
        tabItems: this.dataItems,
        pageTitle: this.pageTitle,
        search: this.search,
        isDelete: true
      }"
      v-on:EditItem="editItemHandler($event)"
      v-on:DeleteItem="deleteItemHandler($event)"
      v-on:NewPressed="newRecordHandler"
    ></app-gridview>
  </div>
</template>
<script>

import GridView from "../../../components/common/GridView";
export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('Setupratingset.ratingsetlisting'),
      dataHeader: [
        { text: this.$t('columns.actions'), value: "action", sortable: false, width: "50px" },
        { text: this.$t('Setupratingset.ratingset'), value: "rateset", width: "200px" },
        { text: this.$t('Setupratingset.ratingsetdesc'), value: "description", width: "200px" },
        { text: this.$t('columns.disable'), value: "disabletext", width: "200px" },
        { text: this.$t('columns.remark'), value: "remark", width: "200px" },
      ],
      dataItems: [],
      loading: false,
      errMsg: "",
       search: this.$route.params.search,
    };
  },

  methods: {
    getRatingSetHandler() {
      const vm = this;
      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/ratingset/all"})
        .then(function (res) {
            vm.dataItems = res.data.rec.map(item => {
              return {
                ...item,
                disabletext: item.disable === 1 ? 'Yes' : 'No'
              };
            });
          vm.loading = !vm.loading;
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    editItemHandler(item) {
      this.$router.push({ name: "ratingsetedit", params: { id: item.id, search: item.search  } });
    },

    deleteItemHandler(item) {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
          return false;
      }

      if (confirm(this.$t('pmratingset.deleteratingset', { code: item.rateset }))) {
        this.$store.dispatch('delete', {url: "/ratingset/" + item.id})
          .then(function () {
            vm.getRatingSetHandler();
          })
          .catch(function (err) {
            vm.errMsg = err;
          });
      }
    },

    newRecordHandler() {
      this.$router.push({ name: "ratingsetnew" });
    },
  },

  mounted() {
    this.getRatingSetHandler();
  },
};
</script>